import React from 'react'
import Slick from 'react-slick'
import clsx from 'clsx'

import * as styles from '../styles/components/Slider.module.scss'

import { Button } from './Button'
import { AnchorLink } from 'gatsby-plugin-anchor-links'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

interface ISlideProps {
  slides: slideInfo[]
}

interface slideInfo {
  title: JSX.Element | string
  description: JSX.Element
  backgroundUrl: JSX.Element
  sameOrigin: boolean
  link?: string
  linkText?: string
}

export const Slider: React.FC<ISlideProps> = ({ slides }) => {
  return (
    <section className={styles.slider}>
      <Slick
        className={styles.slick}
        adaptiveHeight={true}
        infinite={true}
        autoplay={false}
        slidesToShow={1}
        slidesToScroll={1}
        dots={true}
        dotsClass={clsx([`slick-dots`, styles.slickDots])}
      >
        {slides.map((slide, index) => (
          <div key={index} className={styles.slideContainer}>
            <div
              className={styles.slideBackground}
              style={{ backgroundImage: `url(${slide.backgroundUrl})` }}
            />
            <div className={styles.slide}>
              <div className="container">
                <h2>{slide.title}</h2>
                <p>{slide.description}</p>

                {slide.link && slide.linkText && (
                  <>
                    {slide.sameOrigin ? (
                      <AnchorLink to={slide.link}>
                        <Button>{slide.linkText}</Button>
                      </AnchorLink>
                    ) : (
                      <a href={slide.link}>
                        <Button>{slide.linkText}</Button>
                      </a>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </Slick>
    </section>
  )
}
